import React, { useState } from 'react';
import { get, map, isNil, find, head, toNumber, isEmpty, filter, keys, size } from 'lodash';
// import { checkbox as CheckBox } from 'ui/views/generic/checkbox';
import Checkbox from '@material-ui/core/Checkbox';

import FormControlLabel from '@material-ui/core/FormControlLabel';


// local dependencies
import { getLabel } from 'utils/getLabel';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { prescriptionInfoPreloader as PrescriptionInfoPreloader } from 'ui/views/widgets/checkoutPrescriptionInfo';
import { getDisplayValue } from 'resolvers/formatValue';
import { DATA_TYPES } from 'constants/common';
import { BLANK_VALUE_SYMBOL } from 'constants/common';
import { Icon } from 'modules/icon-bank';
import { costCalculation as CostCalculation } from 'ui/views/widgets/costCalculation';
import { button as Button } from 'modules/button';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import searchQuery from 'query-string';
import { Tooltip } from 'modules/tooltip';
import { CREDIT_CARD_TYPE } from 'constants/entity-names';
import { dateRangePicker as DateRangePicker } from 'ui/views/generic/dateRangePicker';
import { format, addDays, getDay } from 'date-fns';
import { disable } from 'colors';

/************************************************* */

// card type icons
const CARD_TYPE_ICON = {
    [ CREDIT_CARD_TYPE.CREDIT_VISA ]: 'visaCard',
    [ CREDIT_CARD_TYPE.MASTER_CARD ]: 'masterCard',
    [ CREDIT_CARD_TYPE.AMERICAN_EXPRESS ]: 'amexCard',
    [ CREDIT_CARD_TYPE.DISCOVER ]: 'discoverCard',
    [ CREDIT_CARD_TYPE.DEBIT_VISA ]: 'visaCard',
    [ CREDIT_CARD_TYPE.DEBIT_MASTER_CARD ]: 'masterCard'
};

const _checkoutConfirmOrder = ( props ) => {
    
    const { widgetConfig, rxItemConfig, prescriptions, shippingPaymentInfo, shippingPaymentInfoConfig = {}, memberId } = props;

    // title and error message info
    const { fieldTitles, errorMessages } = rxItemConfig;

    // get the value of cardCharge
    const cardCharges = toNumber( get( props, 'costCalculation.cardCharges', 0 ) );

    // get the payLater config in case no card charge is there
    const payLaterConfig = get( shippingPaymentInfoConfig, 'cardInfo.config.payLater', {} );

    // check if user has cardInfo
    const showCardInfo = ! isNil( get( shippingPaymentInfo, 'cardInfo', null ) );
    const isVisibleEstimatedCost = props.visibility.confirmOrderEstimatedCost;
    const isVisibleCostCalculation = props.visibility.confirmOrderCostCalculation;
   
    
      
      
    return (
        <div className='ui-checkout-confirm-order'>

            {/* title */}
            <div className='ui-checkout-confirm-order__title'>{ getLabel( widgetConfig.title ) }</div>

            <div className='ui-checkout-confirm-order__body'>
                <div className="ndc-messages">
                    <div style={{ marginBottom: 4 }}>{props.ndcMessage}</div>
                    <div>{props.ndcMsrNote}</div>
                </div>

                { map( prescriptions, prescription => {

                    let rxErrorFlagMessage = null;
                    if( ! isEmpty( prescription.flags ) ) {
                        const flagKeyList = filter( keys( prescription.flags ), key => {
                            return true === prescription.flags[ key ];
                        } );

                        if( 0 !== size( flagKeyList ) ) {
                            const flagKey = head( flagKeyList );
                            rxErrorFlagMessage = get( errorMessages, `${flagKey}`, {} );
                        }
                    }

                    return (
                        <><div key={ prescription.id } className='ui-checkout-confirm-order__body__list'>

                            {/* expired or zero refills flag */}
                            { ! isNil( rxErrorFlagMessage ) && (
                                <div className='ui-checkout-confirm-order__body__list__flag-error'>
                                        <div className='ui-checkout-confirm-order__body__list__flag-error__title'>
                                        <Icon id={ 'flagError' } />
                                        { getLabel( rxErrorFlagMessage ) }
                                    </div>
                                </div>
                            ) }

                            {/* get the prescription number */}
                            <div className='ui-checkout-confirm-order__body__list__rx'
                            >
                                <div className='ui-checkout-confirm-order__body__list__rx__title'>{ getLabel( fieldTitles.rxNumber ) } </div>
                                <div className='ui-checkout-confirm-order__body__list__rx__value ui-checkout-confirm-order__body__list__rx__value--action'
                                onClick={ () => {
                                    props.history.push( {
                                        pathname: DASHBOARD_SUB_ROUTES.PRESCRIPTION_DETAIL,
                                        search: searchQuery.stringify( {
                                            rxId: prescription.id
                                        } ),
                                        state: { memberId: memberId }
                                    } );
                                } }
                                >{ get( prescription, 'rxNumber', BLANK_VALUE_SYMBOL ) } </div>
                            </div>

                            {/* selected drug section */}
                            <div className='ui-checkout-confirm-order__body__list__drugs'>

                                { map( get( prescription, 'drugs', [] ), drug => {

                                    // get daysOfSupply lists
                                    const selectedDaysOfSupply =  find( drug.daysOfSupply, { selected: true } );

                                    // get the estimated value fo drug
                                    const estimatedCost = selectedDaysOfSupply ? getDisplayValue( { type: DATA_TYPES.CURRENCY, value: selectedDaysOfSupply.value } ): BLANK_VALUE_SYMBOL;

                                    return (
                                        <div className='ui-checkout-confirm-order__body__list__drugs__drug' key={ drug.id }>

                                            {/*  drug name */}
                                            <div className='ui-checkout-confirm-order__body__list__drugs__drug__drugName'>
                                                <div className='ui-checkout-confirm-order__body__list__drugs__drug__drugName__title'>
                                                    { getLabel( fieldTitles.drugName ) }

                                                </div>
                                                <div className='ui-checkout-confirm-order__body__list__drugs__drug__drugName__value'>
                                                    { drug.name }
                                                </div>
                                            </div>
                                            
                                            {/* estimated cost based on the no of days supply selected */}
                                           {isVisibleEstimatedCost && <div className='ui-checkout-confirm-order__body__list__drugs__drug__estimated-cost'>
                                                <div className='ui-checkout-confirm-order__body__list__drugs__drug__estimated-cost__title'>
                                                    { getLabel( fieldTitles.estimatedCost ) }
                                                </div>
                                                <div className='ui-checkout-confirm-order__body__list__drugs__drug__estimated-cost__value'>
                                                    { estimatedCost }
                                                </div>
                                            </div>}

                                            {/* days supply selection */}
                                            <div className='ui-checkout-confirm-order__body__list__drugs__drug__daysofsupply'>
                                                <div className='ui-checkout-confirm-order__body__list__drugs__drug__daysofsupply__title'>
                                                    { getLabel( fieldTitles.daysOfSupply ) }
                                                </div>
                                                <div className='ui-checkout-confirm-order__body__list__drugs__drug__daysofsupply__value'>{ head( drug.daysOfSupply )[ 'days' ] }</div>
                                            </div>

                                             {/* drug quantity */}
                                            <div className='ui-checkout-confirm-order__body__list__drugs__drug__'>
                                                <div className='ui-checkout-confirm-order__body__list__drugs__drug__quantity__title'>{ getLabel( fieldTitles.quantity ) } </div>
                                                <div className='ui-checkout-confirm-order__body__list__drugs__drug__quantity__value'>{ head( drug.daysOfSupply )[ 'quantity' ] } </div>
                                            </div>
                                            
                                        </div>
                                        
                                    );
                                } ) }
                            </div>
                        </div>
                        
                      
                    </>
                    );
                } ) }

                {/* cost information */}
                <div className='ui-checkout-confirm-order__body__details'>
                    {isVisibleCostCalculation && <CostCalculation
                        fields = { get( props, 'costCalculationConfig', {} ) }
                        values={ get( props, 'costCalculation', {} ) }
                        mode={ isNaN( cardCharges ) || 0 ===  cardCharges ? 'default': 'deductable' }
                        className={ 'ui-checkout-confirm-order__body__details__card-info' }
                        flags={ get( props, 'flags', {} ) }
                    />}

                    <div className='ui-checkout-confirm-order__body__details__summary'>

                        <div className='ui-checkout-confirm-order__body__details__summary__info'>

                        {props.visibility.confirmOrderPaymentMode && <> <div className='ui-checkout-confirm-order__body__details__summary__info__title'>
                                { showCardInfo ? getLabel( get( shippingPaymentInfoConfig, 'cardInfo.title', {} ) ): getLabel( get( payLaterConfig, 'title' ) ) }
                            </div>


                            {/*  if pay later is active, show the payment mode else the card details */}
                           { showCardInfo ? (

                                <div className='ui-checkout-confirm-order__body__details__summary__info__value'>
                                    <div className={ 'ui-checkout-confirm-order__body__details__summary__info__value__svg' } >
                                        <Icon id={ CARD_TYPE_ICON[ get( shippingPaymentInfo, 'cardInfo.type' ) ] }   />
                                    </div>
                                    <div className='ui-checkout-confirm-order__body__details__summary__info__value__card'>{ get( shippingPaymentInfo, 'cardInfo.lastDigits', BLANK_VALUE_SYMBOL ) }</div>
                                </div>
                                
                            ) : (
                                <div className='ui-checkout-confirm-order__body__details__summary__info__value'>
                            
                                    { ! isEmpty( payLaterConfig ) ? getLabel( payLaterConfig.displayValue ): BLANK_VALUE_SYMBOL }
                                    
                                </div>
                            ) }</>}
                            
                        </div>

                        {props.visibility.confirmOrderShippingMethod && <div className='ui-checkout-confirm-order__body__details__summary__info'>
                            <div className='ui-checkout-confirm-order__body__details__summary__info__title'>{ getLabel( get( shippingPaymentInfoConfig, 'shippingMethod.title', {} ) ) }</div>
                            <div className='ui-checkout-confirm-order__body__details__summary__info__value'>
                                <Tooltip
                                    text={ get( shippingPaymentInfo, 'shippingMethod', BLANK_VALUE_SYMBOL ) }
                                    activateOnOverflow={ true }
                                    render={ ( binding = {} ) => (
                                        <div  { ...binding } className='ui-checkout-confirm-order__body__details__summary__info__value--truncated'>
                                            { get( shippingPaymentInfo, 'shippingMethod', BLANK_VALUE_SYMBOL ) }
                                        </div>
                                    ) }
                                />
                            </div>
                        </div>}

                        <div className='ui-checkout-confirm-order__body__details__summary__info'>
                            <div className='ui-checkout-confirm-order__body__details__summary__info__title'>{ getLabel( get( shippingPaymentInfoConfig, 'estDeliveryDate.title', {} ) ) }</div>
                            <div className='ui-checkout-confirm-order__body__details__summary__info__value'>{ get( shippingPaymentInfo, 'estDeliveryDate', BLANK_VALUE_SYMBOL ) } </div>
                        </div>

                        <div className='ui-checkout-confirm-order__body__details__summary__info'>
                            <div className='ui-checkout-confirm-order__body__details__summary__info__title'>{ getLabel( shippingPaymentInfoConfig.shippingAddress.title ) }</div>
                            <div className='ui-checkout-confirm-order__body__details__summary__info__value'>

                                {/* <Tooltip
                                    text={ getDisplayValue( { type: 'address', value: get( shippingPaymentInfo, 'shippingAddress', {} ) } ) }
                                    activateOnOverflow={ true }
                                    render={ ( binding = {} ) => (
                                        <div  { ...binding } className='ui-checkout-confirm-order__body__details__summary__info__value--truncated'>
                                            { getDisplayValue( { type: 'address', value: get( shippingPaymentInfo, 'shippingAddress', {} ) } ) }
                                        </div>
                                    ) }
                                /> */}

                                { getDisplayValue( { type: 'address', value: get( shippingPaymentInfo, 'shippingAddress', {} ), returnType: 'text' } ) }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='ui-checkout-confirm-order__footer'>
                {
                    map( props.navActions, action => {
                        return(
                            <Button
                                key={ action.name }
                                title={ action.title }
                               
                                size='large'
                                outline={ 'placeOrder' === action.name ? false: true }
                                className='ui-checkout-confirm-order__footer__action'
                                showIcon={ 'prev' === action.name ? true: false }
                                iconId={ 'leftArrow' }
                                iconWidth={ 18 }
                                iconHeight={ 18 }
                                onClick={ () => props.onActionClick( { type: 'navAction', value: action } ) }
                            />
                        );
                    } )
                }
                <div>{props.errorMessage}</div>

            </div>
        </div>
    );
};

// set display name
_checkoutConfirmOrder.displayName = 'checkoutConfirmOrder';

// set default props
_checkoutConfirmOrder.defaultProps = {};

// prop types
_checkoutConfirmOrder.propTypes = {};

/****************************************************** */

/*************************************** */

const checkoutConfirmOrderPreloader = ( ) => {
    return (
        <div className='ui-checkout-confirm-order-preloader'>
            <PrescriptionInfoPreloader />
            {/* <div className=''>

            </div> */}

        </div>
    );
};

// set display name
checkoutConfirmOrderPreloader.displayName = 'checkoutConfirmOrderPreloader';

// set default props
checkoutConfirmOrderPreloader.defaultProps = {};

// prop types
checkoutConfirmOrderPreloader.propTypes = {};


/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { checkoutConfirmOrder as CheckoutConfirmOrder } from 'ui/views/widgets/checkoutConfirmOrder';
 *
 * // render
 * <CheckoutConfirmOrder propName='propValue'/>
 */
export const checkoutConfirmOrder = withNetworkState( checkoutConfirmOrderPreloader, _checkoutConfirmOrder );
